import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { NavigationActions } from '@next/core-lib/navigation';
import { SiteState } from '@next/core-lib/site';
import { UserSelectors } from '@next/core-lib/user';
import { WrapperSiteSidenavComponent } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { DAIRY_START_MONITOR_APPLICATION_KEY } from './shared/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [WrapperSiteSidenavComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);

  private readonly navigationItems = [
    {
      relativeUrl: '/measurements',
      label: 'height-measurement.nav',
      applicationKey: DAIRY_START_MONITOR_APPLICATION_KEY,
    },
    {
      relativeUrl: '/monitoring',
      label: 'height-measurement.monitoring.title',
      applicationKey: DAIRY_START_MONITOR_APPLICATION_KEY,
    },
    {
      relativeUrl: '/insemination-advice',
      label: 'insemination-advice.nav',
      applicationKey: DAIRY_START_MONITOR_APPLICATION_KEY,
    },
  ] as const;

  ngOnInit() {
    const userInitialized$ = this.store.select(UserSelectors.selectUserInitialized);

    const permissionStreams$ = this.navigationItems.map((item) =>
      this.store
        .select(AuthorizationSelectors.hasAtLeastCustomerRoleForApplicationKey(item.applicationKey))
        .pipe(filter((val) => val !== undefined)),
    );

    combineLatest([userInitialized$, ...permissionStreams$])
      .pipe(
        filter(([userInitialized]) => userInitialized),
        take(1),
      )
      .subscribe(([_, ...permissions]) => {
        const filteredNavigationItems = this.navigationItems.filter(
          (_item, index) => permissions[index],
        );

        this.store.dispatch(
          NavigationActions.setNavigationItems({
            navigationItems: filteredNavigationItems,
          }),
        );
      });
  }
}
